export const apiKeysStatus = [
  'Active',
  'Active in future',
  'Expired',
  'Deactivated',
];

export const usedPeriod = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 60, label: 'Last 60 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 0, label: 'All time' },
];
